export default class ClientsSlider {
  constructor() {
    this.selector = '.c-clients-slider';
  }

  // eslint-disable-next-line class-methods-use-this
  bootstrap() {
    const components = document.querySelectorAll(this.selector);
    components.forEach(component => {
      const sliderDesktop = component.querySelector('.c-clients-slider__slider--desktop');
      const flktyDesktop = new Flickity(sliderDesktop, {
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        arrowShape: 'M83.3333333 45.8333333 32.625 45.8333333 55.9166667 22.5416667 50 16.6666667 16.6666667 50 50 83.3333333 55.875 77.4583333 32.625 54.1666667 83.3333333 54.1666667z'
      });


      const sliderMobile = component.querySelector('.c-clients-slider__slider--mobile');
      const flktyMobile = new Flickity(sliderMobile, {
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false
      });
    });
  }


}
